/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseClasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.SystemToolbox {
    'use strict';

    export class SystemToolboxContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

        public worldpayMerchantAccounts: Model.MerchantAccount[] = [];
        public meevoPayMerchantAccounts: Model.MerchantAccount[] = [];
        public auditNoun = Meevo.Model.NounEnum.SystemToolbox;
        public multiLocationList: Model.Location[] = [];

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $rootScope: angular.IRootScopeService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: ng.IQService,
            protected $http: ng.IHttpService,
            protected $timeout: ng.ITimeoutService,
            protected controller: Meevo.Plugins.SystemToolbox.SystemToolboxController
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.sectionTemplatePath = 'app/plugins/systemToolbox/sectionViews/';
            this.baseEndpoint = `api/${this.appSettings.API_ENDPOINTS.systemToolbox}`;
            this.initializeSections();
            this.selectedSection = this.sections[0];
        }

        private filterMerchantAccounts(merchantAccounts: Model.MerchantAccount[]) {
            const worldpayAccounts = merchantAccounts.filter(merchantAccount =>
                merchantAccount.merchantProviderId === Model.MerchantAccountProviderEnum.Worldpay);

            const meevoPayAccounts = merchantAccounts.filter(merchantAccount =>
                (merchantAccount.merchantProviderId === Model.MerchantAccountProviderEnum.MeevoPay ||
                 merchantAccount.merchantProviderId === Model.MerchantAccountProviderEnum.MeevoPayCanada) &&
                merchantAccount.objectState === Model.ObjectStateEnum.Active);

            return { worldpayAccounts, meevoPayAccounts };
        }

        public getMerchantAccountsCO() {
            const locationRequest = {
                criteria: {
                    filterBySessionUser: true,
                    zipCode: ''
                },
                itemsPerPage: 10000,
            };

            const merchantAccountRequest = {
                criteria: {
                    coSearchType: Meevo.Model.CoSearchType.CentralOffice,
                    coSearchResultsFilter: Meevo.Model.CoSearchResultsFilter.All,
                    includeActive: true,
                    includeInactive: true,
                },
                itemsPerPage: 10000,
            };

            const promises = [
                this.dataService.customMethodData('api/location/list', 'POST', locationRequest),
                this.dataService.customMethodData("api/merchantAccount/list", "POST", merchantAccountRequest),
            ];

            return this.$q.all(promises).then(([ locationResponse, merchantAccountResponse ]) => {
                const locations: Model.Location[] = locationResponse.data;
                const merchantAccounts: Model.MerchantAccount[] = merchantAccountResponse.data;

                this.multiLocationList = [];

                for (const location of locations) {
                    const locationMerchantAccounts = merchantAccounts.filter(merchantAccount =>
                        merchantAccount['atLocationId'] == location.locationId);

                    if (locationMerchantAccounts.length === 0) {
                        continue;
                    }

                    const { worldpayAccounts, meevoPayAccounts } = this.filterMerchantAccounts(locationMerchantAccounts);

                    if (worldpayAccounts.length === 0 || meevoPayAccounts.length === 0) {
                        continue;
                    }

                    location['worldpayMerchantAccounts'] = worldpayAccounts;
                    location['meevoPayMerchantAccounts'] = meevoPayAccounts;

                    this.multiLocationList.push(location);
                }

                return this.multiLocationList;
            });
        }

        public getMerchantAccounts() {
            const merchantAccountRequest = {
                criteria: {
                    includeActive: true,
                    includeInactive: true,
                },
                itemsPerPage: 10000,
            };

            return this.dataService.customMethodData("api/merchantAccount/list", "POST", merchantAccountRequest).then((response) => {
                const merchantAccounts: Model.MerchantAccount[] = response.data;

                const { worldpayAccounts, meevoPayAccounts } = this.filterMerchantAccounts(merchantAccounts);

                this.worldpayMerchantAccounts = worldpayAccounts;
                this.meevoPayMerchantAccounts = meevoPayAccounts;

                return merchantAccounts;
            });
        }

        protected initializeSections(): void {
            let sectionId = 0;

            this.sections.push(
                new MainSection(sectionId++,
                    'SECTION_MAIN',
                    'main.html',
                    true,
                    true,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    this.securityChecker,
                    Meevo.Model.NounEnum.SystemToolboxMain,
                    this.appSettings,
                    this.modalService,
                    null,
                    this,
                    this.$rootScope,
                    this.busyService,
                    this.$translate)
            );

            const addTokenMigrationSection = () => {
                this.sections.push(
                    new TokenMigrationSection(sectionId++,
                        'SECTION_TOKEN_MIGRATION',
                        'tokenMigration.html',
                        true,
                        true,
                        this.baseEndpoint,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        this.securityChecker,
                        Meevo.Model.NounEnum.SystemToolboxTokenMigration,
                        this.appSettings,
                        this.modalService,
                        this.securityKeys.BUSINESSINFO_SYSTEMTOOLBOX_FIELD_TOKENMIGRATION,
                        this,
                        this.$q,
                        this.busyService,
                        this.$translate,
                        this.$http,
                        this.$timeout)
                );
            };

            if (this.identityService.inCentralOfficeMode()) {
                this.getMerchantAccountsCO().then(() => {
                    if (this.multiLocationList.length > 0) {
                        addTokenMigrationSection();
                    }
                    else {
                        console.log('CO Token Migration tab hidden due to no locations with Worldpay and MeevoPay merchant accounts.');
                    }
                });
                return;
            }

            this.getMerchantAccounts().then(() => {
                if (this.worldpayMerchantAccounts.length > 0 && this.meevoPayMerchantAccounts.length > 0) {
                    addTokenMigrationSection();
                }
                else {
                    console.log('Token Migration tab hidden due to missing Worldpay or MeevoPay merchant accounts.');
                }
            });
        }

        protected initializeHeader(model: any): void {
        }

        get showEdit(): boolean {
            return false;
        }

        get canEdit(): boolean {
            return false;
        }

        get canCancel(): boolean {
            return this.isAdding || this.isCopying ||
                (this.isEditing &&
                    this.selectedSection !== null &&
                    !this.selectedSection.handlesOwnCrud);
        }

        public saveTrackingInfo(verb: Model.VerbEnum, payload: any = {}, shortDescription: string = ''): void {
            var trackingItem = new Model.TrackingItem(
                this.selectedSection.noun || Model.NounEnum.SystemToolbox,
                verb,
                payload,
                Model.NounClassEnum.SystemToolbox,
                shortDescription
            );
            this.trackingService.saveTrackingInfo(trackingItem);
        }
    }
}